import { cn } from "@teamworksdev/react";
import { type ElementType, forwardRef, type HTMLProps } from "react";

export const Card = forwardRef<HTMLElement, HTMLProps<HTMLElement> & { as?: ElementType }>(
  ({ as = "div", className, ...props }, ref) => {
    const Component = as;

    return (
      <Component
        className={cn(
          "border border-light-200 rounded-lg shadow-xs p-3",
          { "bg-white": !className?.match(/(?<!:)bg-/) }, // Add bg-white if bg-* is not already present
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);

Card.displayName = "Card";
